module.exports = __webpack_public_path__ + "img/icon-info-filled.03d974ad.svg";